// extracted by mini-css-extract-plugin
module.exports = {"container":"e_FA","button":"e_GA","darkModeToggle":"e_HA","icon":"e_IA","buttonText":"e_JA"};